import searchActions from 'Shared/hooks/search'
import { createSlice } from '@reduxjs/toolkit'

const reducer = createSlice({
  name: 'search',
  initialState: {},
  reducers: {
    set: (s, a) => a.payload,
    upsert: (s, a) => ({ ...s, ...a.payload }),
  },
}).reducer
const actions = searchActions

export { reducer, actions }
export default { reducer, actions }
